import { createTableSessionStore } from '@/components/admin/shared/hooks/table-session-store'

/** Session-storage slice for the master questions table. */
export const problemsTableStore = createTableSessionStore(
  'bctci-problems-table',
)

/** Interface for persisted filter state */
export interface PersistedFilterState {
  globalFilter: string
  difficultyFilter: string | null
  sourceFilter: string | null
  studyPlanFilter: string[]
  tagsFilter: string[]
}

/** Default filter state */
export const DEFAULT_FILTER_STATE: PersistedFilterState = {
  globalFilter: '',
  difficultyFilter: null,
  sourceFilter: null,
  studyPlanFilter: [],
  tagsFilter: [],
}
